import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useDebouncedAsyncSelect } from "../../../../../../Utils/Hooks/useDebounce";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import { MigaDesechoApi } from "../api/MigaDesechoApi";

// Semanas ya reportadas, incluidas las que se reportaron en 0 y las canceladas.
// Los kg se pueden corregir mientras el laboratorio no valide el DRC
export const useHistorialMiga = ({ tabActiva }) => {
    const {
        getPadresProductoTerminado,
        getHistorialMigaDesecho,
        editarKgMigaDesecho,
        cancelarMigaDesecho,
        cargando,
    } = MigaDesechoApi();

    const [registros, setRegistros] = useState([]);
    const [totales, setTotales] = useState({ kg_humedos: 0, kg_secos: 0 });
    const [cantidadResultados, setCantidadResultados] = useState(0);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(1);
    const [padreProductoTerminadoFiltro, setPadreProductoTerminadoFiltro] =
        useState(null);

    const [registroEnEdicion, setRegistroEnEdicion] = useState(null);
    const [kgHumedosInput, setKgHumedosInput] = useState("");

    const loadPadresProductoTerminado = useDebouncedAsyncSelect(function (
        search,
    ) {
        return getPadresProductoTerminado({ search });
    });

    const GetHistorial = async () => {
        try {
            const params = { page: paginaSeleccionada };

            if (padreProductoTerminadoFiltro) {
                params.padre_producto_terminado_id =
                    padreProductoTerminadoFiltro.id;
            }

            const data = await getHistorialMigaDesecho(params);

            setRegistros((data && data.results) || []);
            setCantidadResultados((data && data.count) || 0);
            setTotales(
                (data && data.totales) || { kg_humedos: 0, kg_secos: 0 },
            );
        } catch (error) {
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            NotificationManager.error(
                getErrorFromResponse(
                    error,
                    "Error al obtener el historial de miga de desecho",
                ),
                "Error",
                3000,
            );

            setRegistros([]);
            setCantidadResultados(0);
            setTotales({ kg_humedos: 0, kg_secos: 0 });
        }
    };

    useEffect(() => {
        setPaginaSeleccionada(1);
    }, [padreProductoTerminadoFiltro]);

    useEffect(() => {
        if (!tabActiva) return;

        GetHistorial();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginaSeleccionada, padreProductoTerminadoFiltro, tabActiva]);

    const AbrirModalEdicion = (registro) => {
        setRegistroEnEdicion(registro);
        setKgHumedosInput(registro.kg_humedos);
    };

    const CerrarModalEdicion = () => {
        setRegistroEnEdicion(null);
        setKgHumedosInput("");
    };

    const EditarKg = async () => {
        if (kgHumedosInput === "" || kgHumedosInput === null) {
            NotificationManager.warning(
                "Debe ingresar los kilos húmedos de la miga. Si no hubo miga esta semana, ingrese 0",
                "Advertencia",
                3000,
            );
            return;
        }

        try {
            await editarKgMigaDesecho(registroEnEdicion.id, {
                kg_humedos: parseFloat(kgHumedosInput),
            });

            NotificationManager.success(
                "Miga de desecho actualizada con éxito",
                "Éxito",
                3000,
            );

            CerrarModalEdicion();
            await GetHistorial();
        } catch (error) {
            NotificationManager.error(
                getErrorFromResponse(
                    error,
                    "Error al actualizar la miga de desecho",
                ),
                "Error",
                3000,
            );
        }
    };

    const CancelarReporte = async (registroId) => {
        try {
            await cancelarMigaDesecho(registroId);

            NotificationManager.success(
                "Reporte de miga de desecho cancelado con éxito",
                "Éxito",
                3000,
            );

            await GetHistorial();
        } catch (error) {
            NotificationManager.error(
                getErrorFromResponse(
                    error,
                    "Error al cancelar el reporte de miga de desecho",
                ),
                "Error",
                3000,
            );
        }
    };

    return {
        registros,
        totales,
        cantidadResultados,
        paginaSeleccionada,
        setPaginaSeleccionada,
        padreProductoTerminadoFiltro,
        setPadreProductoTerminadoFiltro,
        loadPadresProductoTerminado,
        Refrescar: GetHistorial,

        registroEnEdicion,
        AbrirModalEdicion,
        CerrarModalEdicion,

        kgHumedosInput,
        setKgHumedosInput,

        EditarKg,
        CancelarReporte,
        cargando,
    };
};
